import { Button, type ButtonProps } from '@chakra-ui/react';

/** Shared visual shell for the evidence actions shown beneath an assistant response. */
function EvidenceTriggerButton(props: ButtonProps) {
	return (
		<Button
			type="button"
			variant="ghost"
			size="sm"
			textStyle="label.sm"
			rounded="full"
			px={2.5}
			gap={1.5}
			color="fg.muted"
			_hover={{ bg: 'brand.muted' }}
			{...props}
		/>
	);
}

export default EvidenceTriggerButton;
